import styled from 'styled-components';

const Text = styled.p.attrs(() => ({className: 'light'}))`
    line-height: 2rem;
`;

export default Text;
